export default __webpack_public_path__ + "static/media/F0002.a7f89096.png";